import axios from 'axios'
import { normalizeError } from './utils'

const autoVersioningService = () => {
  const setVersion = async (accessToken, indexVersion) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'text/plain' } }
      await axios.post('/api/autoVersioning/versions', indexVersion, config)
    } catch (error) {
      throw normalizeError(error)
    }
  }

  const setBrands = async (accessToken, brandsToIndex) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      await axios.post('/api/autoVersioning/brands', brandsToIndex, config)
    } catch (error) {
      throw normalizeError(error)
    }
  }

  const unconfirm = async (accessToken) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      await axios.post('/api/autoVersioning/unconfirm', null, config)
    } catch (error) {
      throw normalizeError(error)
    }
  }

  const kickoff = async (accessToken) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      await axios.post('/api/autoVersioning/kickoff', null, config)
    } catch (error) {
      throw normalizeError(error)
    }
  }

  const fetchProgress = async (accessToken) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      const response = await axios.get('/api/autoVersioning/progress', config)
      return response.data
    } catch (error) {
      throw normalizeError(error)
    }
  }

  const reset = async (accessToken) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      await axios.post('/api/autoVersioning/reset', null, config)
    } catch (error) {
      throw normalizeError(error)
    }
  }

  const cancel = async (accessToken) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      await axios.post('/api/autoVersioning/cancel', null, config)
    } catch (error) {
      throw normalizeError(error)
    }
  }

  const rollback = async (accessToken) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      await axios.post('/api/autoVersioning/rollback', null, config)
    } catch (error) {
      throw normalizeError(error)
    }
  }

  return {
    setVersion,
    setBrands,
    unconfirm,
    kickoff,
    fetchProgress,
    reset,
    cancel,
    rollback,
  }
}

export default autoVersioningService()
